export const TIMING = {
  // State transitions
  FADE_OUT: 300,
  FADE_IN: 400,
  STAGGER_DELAY: 150,

  // Recording
  RECORD_PULSE: 1500,
  IDLE_PULSE: 3000,

  // Reflection. Continue's fade runs CONCURRENT with the card entrance (no
  // extra delay): any window where a secondary is actionable while the
  // primary is not re-creates the solo-window hierarchy failure (Codex r1/r2
  // P1). The Adjust caption fades on the same 400ms lifecycle so both actions
  // reveal together.
  CONTINUE_DELAY: 0,
  CARD_ENTER: 400,
  CARD_TEXT_DELAY: 100,

  // Processing
  DOT_BREATHE: 800,
  SLOW_PROCESSING: 7500,

  // Progress
  PROGRESS_MOVE: 600,
} as const;

/** easeOutQuart cubic-bezier shared by session-phase motion. */
export const EASE_OUT_QUART: [number, number, number, number] = [0.25, 1, 0.5, 1];
